import { useMemo } from 'react'

import { useApolloClient } from '@apollo/client'

import {
  createCategoryAsyncFilter,
  createCurrencyAsyncFilter,
  createEmployeeIdsAsyncFilter,
  createLegalEntityIdsAsyncFilter,
  createSubcategoryAsyncFilter,
  pendingApprovalFilter,
  reportDateFilter,
  statusFilter,
} from 'modules/expenses/components/expenses/DataCollection/filters'
import { reportedByFilter } from 'modules/expenses/components/my_expenses/DataCollection/_Filters/reportedByFilter'

interface UseGroupsFiltersProps {
  companyId: number
  isMyExpenses?: boolean
}

export const useGroupsFilters = ({ companyId, isMyExpenses = false }: UseGroupsFiltersProps) => {
  const apolloClient = useApolloClient()

  return useMemo(
    () => ({
      reviewRequestAt: reportDateFilter(),
      category: createCategoryAsyncFilter(apolloClient, companyId),
      currency: createCurrencyAsyncFilter(apolloClient, companyId),
      ...(isMyExpenses ? { reportedBy: reportedByFilter() } : {}),
      ...(!isMyExpenses ? { employeeIds: createEmployeeIdsAsyncFilter(apolloClient, companyId) } : {}),
      ...(!isMyExpenses ? { legalEntityIds: createLegalEntityIdsAsyncFilter(apolloClient) } : {}),
      ...(!isMyExpenses ? { pendingApproval: pendingApprovalFilter() } : {}),
      status: statusFilter(),
      subcategory: createSubcategoryAsyncFilter(apolloClient, companyId),
    }),
    [apolloClient, companyId, isMyExpenses]
  )
}
